// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.98.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.98.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-page {
  max-width: 1400px;
  margin: 0 auto;
  padding: 40px 0 64px 0;
  background: black;
  min-height: 100vh;
  color: #fff;
}

.trending-section {
  margin-bottom: 48px;
}
.trending-title {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 18px;
  color: #fff;
}
.trending-tabs {
  display: flex;
  gap: 12px;
  margin-bottom: 18px;
}
.trending-tab {
  background: #232323;
  color: lightgray;
  border: none;
  border-radius: 18px;
  padding: 7px 15px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}
.trending-tab.active {
  background: #fff;
  color: #181818;
  font-weight: bold;
}
.trending-rank-container {
  display: flex;
  gap: 60px;
  margin-bottom: 10px;
}
.trending-list {
  list-style: none;
  padding: 0;
  margin: 0;
  width: 340px;
}
.trending-list.left {
  text-align: left;
}
.trending-list.right {
  text-align: left;
}
.trending-item {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
  font-size: 1.15rem;
  color: #bbb;
  font-weight: 500;
  min-height: 56px;
}
.trending-rank {
  width: 24px;
  text-align: right;
  font-size: 1.18rem;
  font-weight: bold;
  margin-right: 8px;
}
.trending-poster {
  width: 38px;
  height: 54px;
  object-fit: cover;
  border-radius: 4px;
  margin-right: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.18);
}
.trending-title-text {
  color: #fff;
  font-size: 1rem;
  font-weight: 100;
  letter-spacing: -0.5px;
  transition: font-size 0.35s, font-weight 0.35s, color 0.35s;
  cursor: pointer;
}

.trending-title-text:hover {
  color: #ff2f6e;
}

/* 순위별 스타일 */
.rank-1 .trending-rank,
.rank-1 .trending-title-text { color: lightgray; }
.rank-2 .trending-rank,
.rank-2 .trending-title-text { color: lightgray; }
.rank-3 .trending-rank,
.rank-3 .trending-title-text { color: lightgray; }
.rank-4 .trending-rank,
.rank-4 .trending-title-text { color: lightgray; }
.rank-5 .trending-rank,
.rank-5 .trending-title-text { color: lightgray; }
.rank-6 .trending-rank,
.rank-6 .trending-title-text { color: lightgray; }
.rank-7 .trending-rank,
.rank-7 .trending-title-text { color: lightgray; }
.rank-8 .trending-rank,
.rank-8 .trending-title-text { color: lightgray; }
.rank-9 .trending-rank,
.rank-9 .trending-title-text { color: lightgray; }
.rank-10 .trending-rank,
.rank-10 .trending-title-text { color: lightgray; }

.trending-date {
  color: #888;
  font-size: 0.98rem;
  margin-top: 8px;
}

.category-container {
  margin-top: 36px;
}
.category-container h3 {
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 16px;
  color: #fff;
}
.category-list {
  display: flex;
  gap: 18px;
}

.search-title {
  font-size: 24px;
  margin-bottom: 10px;
}

.search-rank {
  list-style: none;
  padding: 0;
}

.search-rank li {
  font-size: 18px;
  padding: 5px 0;
}

.category-item {
  background: #222;
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;
}

.trending-main-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
  min-height: 320px;
}

.trending-left {
  z-index: 2;
  position: relative;
  width: 100%;
  max-width: 800px;
}

.trending-list.vertical {
  display: flex;
  flex-direction: row;
  gap: 40px;
  margin: 0 0 18px 0;
  padding: 0;
  list-style: none;
  width: 100%;
}

.trending-list-column {
  display: flex;
  flex-direction: column;
  gap: 0;
  width: 50%;
}

.trending-item.vertical {
  display: flex;
  align-items: center;
  font-size: 1.18rem;
  color: #fff;
  margin-bottom: 2px;
  font-weight: 400;
  transition: font-size 0.25s, font-weight 0.25s, color 0.25s;
  cursor: pointer;
  position: relative;
}
.trending-item.vertical.bold .trending-title-text {
  font-weight: 300;
}
.trending-item.vertical.active .trending-title-text {
  font-size: 1.35rem;
  font-weight: bold;
  font-family: sans-serif;
  color: #fff;
  letter-spacing: -0.5px;
  transition: font-size 0.25s, font-weight 0.25s, color 0.25s;
}
.trending-item.vertical.active .trending-rank {
  font-size: 1.35rem;
  color: #ff2f6e !important;
  font-weight: bold;
  transition: font-size 0.25s, color 0.25s;
}
.trending-rank {
  width: 24px;
  text-align: right;
  font-size: 1.18rem;
  font-weight: 100;
  margin-right: 16px;
  color: #ff2f6e !important;
  transition: font-size 0.25s, color 0.25s;
}
.trending-title-text {
  color: #fff;
  font-size: 1rem;
  font-weight: 100;
  letter-spacing: -0.5px;
  transition: font-size 0.35s, font-weight 0.35s, color 0.35s;
}
.trending-date {
  color: #888;
  font-size: 0.98rem;
  margin-top: 8px;
}

.trending-poster-bg {
  flex: 1;
  position: relative;
  min-width: 0;
  height: 441px;
  margin-right: 20px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  z-index: 1;
}
.trending-main-poster {
  width: 100%;
  max-width: 600px;
  height: 441px;
  object-fit: cover;
  border-radius: 0 0 0 0;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  pointer-events: none;
  transition: opacity 0.3s ease;
}

.trending-main-poster-blur-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  pointer-events: none;
  background: linear-gradient(
    to right,
    rgba(0,0,0,1) 0%,
    rgba(0,0,0,0.7) 20%,
    rgba(0,0,0,0.6) 40%,
    rgba(0,0,0,0.5) 60%,
    rgba(0,0,0,0.3) 80%,
    rgba(0,0,0,0.1) 100%
  ),
  linear-gradient(
    to bottom,
    rgba(0,0,0,1) 0%,
    rgba(0,0,0,0.3) 20%,
    rgba(0,0,0,0) 40%,
    rgba(0,0,0,0) 60%,
    rgba(0,0,0,0.3) 80%,
    rgba(0,0,0,1) 100%
  );
  transition: opacity 0.3s ease;
}

.trending-item.vertical:hover .trending-title-text {
  font-size: 1.35rem;
  font-weight: bold;
  font-family: sans-serif;
  color: #fff;
  letter-spacing: -0.5px;
  transition: font-size 0.25s, font-weight 0.25s, color 0.25s;
}

.trending-item.vertical:hover .trending-rank {
  font-size: 1.35rem;
  color: #ff2f6e !important;
  font-weight: bold;
  transition: font-size 0.25s, color 0.25s;
}

.trending-item.vertical:hover .trending-main-poster {
  opacity: 0;
  transition: opacity 0.3s ease;
}

.trending-item.vertical:hover .trending-main-poster-blur-mask {
  opacity: 0;
  transition: opacity 0.3s ease;
}

.search-result-group {
  margin-top: 32px;
}
.search-result-category {
  margin-bottom: 36px;
}
.search-result-category h3 {
  font-size: 1.1rem;
  font-weight: bold;
  color: #fff;
  margin-bottom: 16px;
  border-bottom: 1px solid #222;
  padding-bottom: 6px;
}
.search-result-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.search-result-item {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 8px 0;
  cursor: pointer;
  transition: background 0.18s;
  border-radius: 8px;
}
.search-result-item:hover {
  background: rgba(255,255,255,0.06);
}
.search-result-poster {
  width: 48px;
  height: 68px;
  object-fit: cover;
  border-radius: 6px;
  background: #222;
  box-shadow: 0 2px 8px rgba(0,0,0,0.18);
}
.search-result-poster.person {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
}
.search-result-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.search-result-title {
  font-size: 1rem;
  font-weight: 500;
  color: #fff;
  margin-bottom: 2px;
}
.search-result-meta {
  font-size: 0.95rem;
  color: #bbb;
}
`, "",{"version":3,"sources":["webpack://./src/styles/SearchPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,uCAAuC;AACzC;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,sCAAsC;AACxC;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,2DAA2D;EAC3D,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,YAAY;AACZ;+BAC+B,gBAAgB,EAAE;AACjD;+BAC+B,gBAAgB,EAAE;AACjD;+BAC+B,gBAAgB,EAAE;AACjD;+BAC+B,gBAAgB,EAAE;AACjD;+BAC+B,gBAAgB,EAAE;AACjD;+BAC+B,gBAAgB,EAAE;AACjD;+BAC+B,gBAAgB,EAAE;AACjD;+BAC+B,gBAAgB,EAAE;AACjD;+BAC+B,gBAAgB,EAAE;AACjD;gCACgC,gBAAgB,EAAE;;AAElD;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,2DAA2D;EAC3D,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,WAAW;EACX,sBAAsB;EACtB,2DAA2D;AAC7D;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,wCAAwC;AAC1C;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,wCAAwC;AAC1C;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,2DAA2D;AAC7D;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,UAAU;AACZ;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,UAAU;EACV,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB;;;;;;;;;;;;;;;;;GAiBC;EACD,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,WAAW;EACX,sBAAsB;EACtB,2DAA2D;AAC7D;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;AACpB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;AACxC;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb","sourcesContent":[".search-page {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 40px 0 64px 0;\n  background: black;\n  min-height: 100vh;\n  color: #fff;\n}\n\n.trending-section {\n  margin-bottom: 48px;\n}\n.trending-title {\n  font-size: 1.5rem;\n  font-weight: bold;\n  margin-bottom: 18px;\n  color: #fff;\n}\n.trending-tabs {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 18px;\n}\n.trending-tab {\n  background: #232323;\n  color: lightgray;\n  border: none;\n  border-radius: 18px;\n  padding: 7px 15px;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.2s, color 0.2s;\n}\n.trending-tab.active {\n  background: #fff;\n  color: #181818;\n  font-weight: bold;\n}\n.trending-rank-container {\n  display: flex;\n  gap: 60px;\n  margin-bottom: 10px;\n}\n.trending-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  width: 340px;\n}\n.trending-list.left {\n  text-align: left;\n}\n.trending-list.right {\n  text-align: left;\n}\n.trending-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 8px;\n  font-size: 1.15rem;\n  color: #bbb;\n  font-weight: 500;\n  min-height: 56px;\n}\n.trending-rank {\n  width: 24px;\n  text-align: right;\n  font-size: 1.18rem;\n  font-weight: bold;\n  margin-right: 8px;\n}\n.trending-poster {\n  width: 38px;\n  height: 54px;\n  object-fit: cover;\n  border-radius: 4px;\n  margin-right: 8px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.18);\n}\n.trending-title-text {\n  color: #fff;\n  font-size: 1rem;\n  font-weight: 100;\n  letter-spacing: -0.5px;\n  transition: font-size 0.35s, font-weight 0.35s, color 0.35s;\n  cursor: pointer;\n}\n\n.trending-title-text:hover {\n  color: #ff2f6e;\n}\n\n/* 순위별 스타일 */\n.rank-1 .trending-rank,\n.rank-1 .trending-title-text { color: lightgray; }\n.rank-2 .trending-rank,\n.rank-2 .trending-title-text { color: lightgray; }\n.rank-3 .trending-rank,\n.rank-3 .trending-title-text { color: lightgray; }\n.rank-4 .trending-rank,\n.rank-4 .trending-title-text { color: lightgray; }\n.rank-5 .trending-rank,\n.rank-5 .trending-title-text { color: lightgray; }\n.rank-6 .trending-rank,\n.rank-6 .trending-title-text { color: lightgray; }\n.rank-7 .trending-rank,\n.rank-7 .trending-title-text { color: lightgray; }\n.rank-8 .trending-rank,\n.rank-8 .trending-title-text { color: lightgray; }\n.rank-9 .trending-rank,\n.rank-9 .trending-title-text { color: lightgray; }\n.rank-10 .trending-rank,\n.rank-10 .trending-title-text { color: lightgray; }\n\n.trending-date {\n  color: #888;\n  font-size: 0.98rem;\n  margin-top: 8px;\n}\n\n.category-container {\n  margin-top: 36px;\n}\n.category-container h3 {\n  font-size: 1.2rem;\n  font-weight: bold;\n  margin-bottom: 16px;\n  color: #fff;\n}\n.category-list {\n  display: flex;\n  gap: 18px;\n}\n\n.search-title {\n  font-size: 24px;\n  margin-bottom: 10px;\n}\n\n.search-rank {\n  list-style: none;\n  padding: 0;\n}\n\n.search-rank li {\n  font-size: 18px;\n  padding: 5px 0;\n}\n\n.category-item {\n  background: #222;\n  padding: 10px;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.trending-main-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  position: relative;\n  min-height: 320px;\n}\n\n.trending-left {\n  z-index: 2;\n  position: relative;\n  width: 100%;\n  max-width: 800px;\n}\n\n.trending-list.vertical {\n  display: flex;\n  flex-direction: row;\n  gap: 40px;\n  margin: 0 0 18px 0;\n  padding: 0;\n  list-style: none;\n  width: 100%;\n}\n\n.trending-list-column {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  width: 50%;\n}\n\n.trending-item.vertical {\n  display: flex;\n  align-items: center;\n  font-size: 1.18rem;\n  color: #fff;\n  margin-bottom: 2px;\n  font-weight: 400;\n  transition: font-size 0.25s, font-weight 0.25s, color 0.25s;\n  cursor: pointer;\n  position: relative;\n}\n.trending-item.vertical.bold .trending-title-text {\n  font-weight: 300;\n}\n.trending-item.vertical.active .trending-title-text {\n  font-size: 1.35rem;\n  font-weight: bold;\n  font-family: sans-serif;\n  color: #fff;\n  letter-spacing: -0.5px;\n  transition: font-size 0.25s, font-weight 0.25s, color 0.25s;\n}\n.trending-item.vertical.active .trending-rank {\n  font-size: 1.35rem;\n  color: #ff2f6e !important;\n  font-weight: bold;\n  transition: font-size 0.25s, color 0.25s;\n}\n.trending-rank {\n  width: 24px;\n  text-align: right;\n  font-size: 1.18rem;\n  font-weight: 100;\n  margin-right: 16px;\n  color: #ff2f6e !important;\n  transition: font-size 0.25s, color 0.25s;\n}\n.trending-title-text {\n  color: #fff;\n  font-size: 1rem;\n  font-weight: 100;\n  letter-spacing: -0.5px;\n  transition: font-size 0.35s, font-weight 0.35s, color 0.35s;\n}\n.trending-date {\n  color: #888;\n  font-size: 0.98rem;\n  margin-top: 8px;\n}\n\n.trending-poster-bg {\n  flex: 1;\n  position: relative;\n  min-width: 0;\n  height: 441px;\n  margin-right: 20px;\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-end;\n  z-index: 1;\n}\n.trending-main-poster {\n  width: 100%;\n  max-width: 600px;\n  height: 441px;\n  object-fit: cover;\n  border-radius: 0 0 0 0;\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 1;\n  pointer-events: none;\n  transition: opacity 0.3s ease;\n}\n\n.trending-main-poster-blur-mask {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 2;\n  pointer-events: none;\n  background: linear-gradient(\n    to right,\n    rgba(0,0,0,1) 0%,\n    rgba(0,0,0,0.7) 20%,\n    rgba(0,0,0,0.6) 40%,\n    rgba(0,0,0,0.5) 60%,\n    rgba(0,0,0,0.3) 80%,\n    rgba(0,0,0,0.1) 100%\n  ),\n  linear-gradient(\n    to bottom,\n    rgba(0,0,0,1) 0%,\n    rgba(0,0,0,0.3) 20%,\n    rgba(0,0,0,0) 40%,\n    rgba(0,0,0,0) 60%,\n    rgba(0,0,0,0.3) 80%,\n    rgba(0,0,0,1) 100%\n  );\n  transition: opacity 0.3s ease;\n}\n\n.trending-item.vertical:hover .trending-title-text {\n  font-size: 1.35rem;\n  font-weight: bold;\n  font-family: sans-serif;\n  color: #fff;\n  letter-spacing: -0.5px;\n  transition: font-size 0.25s, font-weight 0.25s, color 0.25s;\n}\n\n.trending-item.vertical:hover .trending-rank {\n  font-size: 1.35rem;\n  color: #ff2f6e !important;\n  font-weight: bold;\n  transition: font-size 0.25s, color 0.25s;\n}\n\n.trending-item.vertical:hover .trending-main-poster {\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.trending-item.vertical:hover .trending-main-poster-blur-mask {\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.search-result-group {\n  margin-top: 32px;\n}\n.search-result-category {\n  margin-bottom: 36px;\n}\n.search-result-category h3 {\n  font-size: 1.1rem;\n  font-weight: bold;\n  color: #fff;\n  margin-bottom: 16px;\n  border-bottom: 1px solid #222;\n  padding-bottom: 6px;\n}\n.search-result-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n.search-result-item {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 8px 0;\n  cursor: pointer;\n  transition: background 0.18s;\n  border-radius: 8px;\n}\n.search-result-item:hover {\n  background: rgba(255,255,255,0.06);\n}\n.search-result-poster {\n  width: 48px;\n  height: 68px;\n  object-fit: cover;\n  border-radius: 6px;\n  background: #222;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.18);\n}\n.search-result-poster.person {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n.search-result-info {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n.search-result-title {\n  font-size: 1rem;\n  font-weight: 500;\n  color: #fff;\n  margin-bottom: 2px;\n}\n.search-result-meta {\n  font-size: 0.95rem;\n  color: #bbb;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
